"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      tableData: [], // 列表数据
      searchData: {
        username: '',
        access: '',
        allow: '',
        page: 1, // 当前页码
        rows: 10 // 页码条数
      },

      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 } };


  },
  filters: {
    allowFilter: function allowFilter(val) {
      if (val === 0) {
        return '禁止';
      } else if (val === 1) {
        return '允许';
      } else {
        return val;
      }
    },
    accessFilter: function accessFilter(val) {
      if (val === 1) {
        return '订阅';
      } else if (val === 2) {
        return '发布';
      } else if (val === 3) {
        return '订阅&发布';
      } else {
        return val;
      }
    } },

  mounted: function mounted() {
    var self = this;
    self.init();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/mqttacl', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },

    resetFun: function resetFun() {// 重置
      this.searchData.username = '';
      this.searchData.allow = '';
      this.searchData.access = '';
      this.init();
    },

    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    changeallowFun: function changeallowFun(val) {
      var self = this;
      if (val === '0') {
        self.searchData.allow = '0';
      }if (val === '1') {
        self.searchData.allow = '1';
      }
    },
    changeaccessFun: function changeaccessFun(val) {
      var self = this;
      if (val === '1') {
        self.searchData.access = '1';
      }if (val === '2') {
        self.searchData.access = '2';
      }if (val === '3') {
        self.searchData.access = '3';
      }
    } } };exports.default = _default;